// Source/Care-Prompt/Component.ts
class CarePrompt extends HTMLElement {
  controller;
  async connectedCallback() {
    this.controller = new AbortController;
    this.setupListeners();
    if (this.initialOpen)
      await this.check();
    this.ready = true;
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  setupListeners() {
    const { signal } = this.controller;
    const check = this.check.bind(this);
    this.$checkout_button?.addEventListener("click", check, { capture: true, signal });
    const capture = this.capture.bind(this);
    document.documentElement.addEventListener("click", capture, { capture: true, signal });
    this.addEventListener("click", (event) => {
      if (event.target !== this)
        return;
      event.stopImmediatePropagation();
      event.preventDefault();
      this.$popup.close();
    });
  }
  capture(event) {
    const target = event.target;
    if (!(target instanceof Element))
      return;
    if (target.closest(`care-prompt`))
      return;
    if (!this.loading)
      return;
    event.stopImmediatePropagation();
    event.preventDefault();
  }
  async check(event) {
    event?.stopImmediatePropagation();
    event?.preventDefault();
    const html = await this.fetch();
    if (!html) {
      this.checkout();
      return;
    }
    this.$content.innerHTML = html;
    this.$popup.open();
  }
  checkout() {
    if (this.noCheckout)
      return;
    location.href = "/checkout";
  }
  async fetch() {
    const query = `${"\uD83E\uDE79"}`;
    const { href } = window.location;
    const url = new URL(`/search`, href);
    url.searchParams.set("q", query);
    return await fetch(url).then((response) => response.text()).then((html) => html.trim()).then((html) => html.includes("❌") ? null : html).catch((reason) => {
      console.error(`Failed to fetch Care to a network error`, { reason });
      return null;
    });
  }
  get $checkout_button() {
    return document.querySelector(`button[ form = 'cart-form' ][ name = 'checkout' ]`);
  }
  get $content() {
    return this.querySelector(`.Care-Content`);
  }
  get $popup() {
    return this.querySelector(`care-popup`);
  }
  get initialOpen() {
    return this.dataset.initialOpen === "true";
  }
  get noCheckout() {
    return this.dataset.noCheckout === "true";
  }
  get loading() {
    return this.dataset.loading === "true";
  }
  set loading(state) {
    this.dataset.loading = String(state);
  }
  set ready(state) {
    this.dataset.ready = String(state);
  }
}

// Source/Care-Prompt/mod.ts
customElements.define("care-prompt", CarePrompt);
